import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Choose your start plan <br/> We take care of everything, <underline>YOU</underline> sit back 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Pay later from sales',
    [BillingMode.Stripe]: '(0)[Pay now];(1-inf)[Pay now (save up to {{discount}})]',
  },
};
